import { render } from "./ManagementAnalyticsCard.vue?vue&type=template&id=28b43451&scoped=true"
import script from "./ManagementAnalyticsCard.vue?vue&type=script&lang=js"
export * from "./ManagementAnalyticsCard.vue?vue&type=script&lang=js"

import "./ManagementAnalyticsCard.vue?vue&type=style&index=0&id=28b43451&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b43451"]])

export default __exports__